import type { CommandBarActionId, DeclarationHandlers } from './types'

export type CommandBarActionDefinition = {
  id: CommandBarActionId
  labelKey: string
  shortcut?: string
  requiresDeclaration?: boolean
  requiresReferentialsFeature?: boolean
  isQuickAction?: boolean
  isDeclarationContextual?: boolean
  /** Le geste que l'écran de déclaration doit avoir enregistré pour que l'action serve. */
  handler?: keyof DeclarationHandlers
}

export const COMMAND_BAR_ACTIONS: CommandBarActionDefinition[] = [
  {
    id: 'apply-referential-declaration',
    labelKey: 'actionApplyReferentialDeclaration',
    shortcut: 'T',
    isDeclarationContextual: true,
    handler: 'openAddReferentialToDeclaration',
  },
  {
    id: 'run-automation-declaration',
    labelKey: 'actionRunAutomationDeclaration',
    shortcut: 'U',
    isDeclarationContextual: true,
    handler: 'openRunAutomation',
  },
  {
    id: 'change-model-declaration',
    labelKey: 'actionChangeModelDeclaration',
    shortcut: 'X',
    isDeclarationContextual: true,
    handler: 'openChangeModel',
  },
  {
    id: 'duplicate-folder-declaration',
    labelKey: 'actionDuplicateFolder',
    shortcut: 'L',
    isDeclarationContextual: true,
    handler: 'openDuplicateFolder',
  },
  {
    id: 'create-folder',
    labelKey: 'actionCreateFolder',
    shortcut: 'D',
    isQuickAction: true,
  },
  {
    id: 'add-referential',
    labelKey: 'actionAddReferential',
    shortcut: 'R',
    isQuickAction: true,
    requiresReferentialsFeature: true,
  },
  {
    id: 'add-client',
    labelKey: 'actionAddClient',
    shortcut: 'C',
  },
  {
    id: 'create-automation',
    labelKey: 'actionCreateAutomation',
    shortcut: 'A',
  },
  {
    id: 'apply-automation',
    labelKey: 'actionApplyAutomation',
    shortcut: 'P',
    requiresDeclaration: true,
    handler: 'openApplyAutomation',
  },
  {
    id: 'apply-model',
    labelKey: 'actionApplyModel',
    shortcut: 'M',
    requiresDeclaration: true,
    handler: 'openApplyModel',
  },
  {
    id: 'go-dashboard',
    labelKey: 'actionGoDashboard',
    shortcut: 'H',
  },
  {
    id: 'view-all-documents',
    labelKey: 'actionViewAllDocuments',
    shortcut: 'F',
    isQuickAction: true,
  },
  {
    id: 'open-settings',
    labelKey: 'actionOpenSettings',
    shortcut: 'S',
  },
]

/** L'action sert-elle sur l'écran courant ? Oui si elle n'attend aucun geste, ou si l'écran l'a enregistré. */
export const hasDeclarationHandler = (
  action: CommandBarActionDefinition | undefined,
  handlers: DeclarationHandlers | null
): boolean => !action?.handler || handlers?.[action.handler] != null

export const COMMAND_BAR_QUICK_ACTION_IDS: CommandBarActionId[] =
  COMMAND_BAR_ACTIONS.filter((action) => action.isQuickAction).map(
    (action) => action.id
  )

export const COMMAND_BAR_SHORTCUT_MAP: Partial<
  Record<string, CommandBarActionId>
> = COMMAND_BAR_ACTIONS.reduce(
  (acc, action) => {
    if (action.shortcut) {
      acc[action.shortcut.toLowerCase()] = action.id
    }
    return acc
  },
  {} as Partial<Record<string, CommandBarActionId>>
)
